// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/create_user_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/create_user_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_create_user_request: GenFile = /*@__PURE__*/
  fileDesc("CkFxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3JlYXRlX3VzZXJfcmVxdWVzdC5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIlEKEUNyZWF0ZVVzZXJSZXF1ZXN0Eg8KAmlkGAEgASgJSACIAQESFgoJdGVuYW50X2lkGAIgASgJSAGIAQFCBQoDX2lkQgwKCl90ZW5hbnRfaWRiBnByb3RvMw");

/**
 * Rpc request to create a new user record
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.CreateUserRequest"> & {
  /**
   * The unique identifier for the user to be created
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The tenant identifier the user belongs to
   *
   * @generated from field: optional string tenant_id = 2;
   */
  tenantId?: string;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_create_user_request, 0);

